import { render, staticRenderFns } from "./yxyBox.vue?vue&type=template&id=07f0793d&"
import script from "./yxyBox.vue?vue&type=script&lang=js&"
export * from "./yxyBox.vue?vue&type=script&lang=js&"
import style0 from "./yxyBox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/show/yxyBox.vue
// module id = null
// module chunks = 